import {
  ATTEMPT_SUBMIT_ALERT_WITH_LOCATION,
  ADD_CONTACT_MODAL_CLOSE,
  SAFEWALK_RESET,
  SAFEWALK_SET_DATA,
  SAFEWALK_UPDATE_ALARM,
  SAFEWALK_ALERT_TIMER_SUBMIT_SUCCESS
} from '@actions/types'
import {
  BLUE,
  GUN_GRAY,
  BLACK,
  HOT_PINK,
  WHITE,
  GRADIENTS
} from '@omnilert/components'

import {
  SAFEWALK_ACTIVATED_TEXT,
  SAFEWALK_ALARM_ACTIVE_BODY_TEXT,
  SAFEWALK_ALARM_CANCELLED_BODY_TEXT,
  SAFEWALK_ALARM_ENDED_BODY_TEXT,
  SAFEWALK_ALARM_WARNING_BODY_TEXT,
  BUTTON_SAFEWALK_CANCEL_ALARM,
  BUTTON_SAFEWALK_END_WALK,
  BUTTON_SAFEWALK_NEW_WALK,
  BUTTON_SAFEWALK_TRIGGER_ALARM
} from '@assets/i18n/strings'

const initialState = {
  activeDisplay: null,
  alarmTriggeredManually: false,
  contacts: [],
  showAddContactForm: false,
  formDuration: 0,
  isAwaitingLocation: false,
  isOffHours: false,
  isOnCampus: false,
  nextState: '',
  timerId: null,
  displayStates: [{
    backgroundImage: GRADIENTS.SUCCESS,
    bodyText: SAFEWALK_ACTIVATED_TEXT,
    countdownColor: 'var(--tips__text)',
    gradientId: 'success',
    primaryButtonColor: HOT_PINK,
    primaryButtonId: 'alarm-active',
    primaryButtonText: BUTTON_SAFEWALK_TRIGGER_ALARM,
    primaryButtonTextColor: WHITE,
    primaryButtonVariant: 'solid',
    secondaryButtonColor: GUN_GRAY,
    secondaryButtonId: 'walk-ended',
    secondaryButtonText: BUTTON_SAFEWALK_END_WALK,
    secondaryButtonTextColor: WHITE,
    showEndButton: true,
    showSecondaryButton: true,
    showTimer: true,
    state: 'walk-activated',
    text: '',
    timerColor: BLACK
  }, {
    backgroundImage: null,
    bodyText: SAFEWALK_ALARM_ENDED_BODY_TEXT,
    countdownColor: 'var(--tips__text)',
    gradientId: 'invalid',
    primaryButtonColor: BLUE,
    primaryButtonId: 'reset',
    primaryButtonText: BUTTON_SAFEWALK_NEW_WALK,
    primaryButtonTextColor: BLUE,
    primaryButtonVariant: 'outlined',
    secondaryButtonColor: '',
    secondaryButtonId: '',
    secondaryButtonText: BUTTON_SAFEWALK_END_WALK,
    secondaryButtonTextColor: WHITE,
    showSecondaryButton: false,
    showTimer: false,
    state: 'walk-ended',
    text: 'Safe walk ended',
    timerColor: BLACK
  }, {
    backgroundImage: GRADIENTS.WARNING,
    bodyText: SAFEWALK_ALARM_WARNING_BODY_TEXT,
    countdownColor: 'var(--tips__text)',
    gradientId: 'warning',
    primaryButtonColor: HOT_PINK,
    primaryButtonId: 'alarm-active',
    primaryButtonText: BUTTON_SAFEWALK_TRIGGER_ALARM,
    primaryButtonTextColor: WHITE,
    primaryButtonVariant: 'solid',
    secondaryButtonColor: GUN_GRAY,
    secondaryButtonId: 'walk-ended',
    secondaryButtonText: BUTTON_SAFEWALK_END_WALK,
    secondaryButtonTextColor: WHITE,
    showSecondaryButton: true,
    showTimer: true,
    state: 'warning',
    text: '',
    timerColor: WHITE
  }, {
    backgroundImage: GRADIENTS.ERROR,
    bodyText: SAFEWALK_ALARM_ACTIVE_BODY_TEXT,
    countdownColor: HOT_PINK,
    gradientId: 'error',
    primaryButtonColor: HOT_PINK,
    primaryButtonId: 'alarm-cancelled',
    primaryButtonText: BUTTON_SAFEWALK_CANCEL_ALARM,
    primaryButtonTextColor: WHITE,
    primaryButtonVariant: 'solid',
    secondaryButtonColor: GUN_GRAY,
    secondaryButtonId: '',
    secondaryButtonText: BUTTON_SAFEWALK_END_WALK,
    secondaryButtonTextColor: WHITE,
    showSecondaryButton: false,
    showTimer: true,
    state: 'alarm-active',
    text: '',
    timerColor: WHITE
  }, {
    backgroundImage: null,
    bodyText: SAFEWALK_ALARM_CANCELLED_BODY_TEXT,
    countdownColor: 'var(--tips__text)',
    gradientId: 'invalid',
    primaryButtonColor: BLUE,
    primaryButtonId: 'reset',
    primaryButtonText: BUTTON_SAFEWALK_NEW_WALK,
    primaryButtonTextColor: BLUE,
    primaryButtonVariant: 'outlined',
    secondaryButtonColor: '',
    secondaryButtonId: '',
    secondaryButtonText: BUTTON_SAFEWALK_END_WALK,
    secondaryButtonTextColor: WHITE,
    showSecondaryButton: false,
    showTimer: false,
    state: 'alarm-cancelled',
    text: 'Safe walk alarm cancelled',
    timerColor: BLACK
  }]
}

const reducer = (state = initialState, action) => {
  const { payload, type } = action

  switch (type) {
  case ADD_CONTACT_MODAL_CLOSE:
    return {
      ...state,
      showAddContactForm: false
    }
  case SAFEWALK_SET_DATA:
    return {
      ...state,
      ...payload
    }
  case SAFEWALK_UPDATE_ALARM:
    return {
      ...state,
      ...payload
    }
  case ATTEMPT_SUBMIT_ALERT_WITH_LOCATION:
    return {
      ...state,
      ...payload
    }
  case SAFEWALK_RESET:
    return {
      ...state,
      ...initialState
    }
  case SAFEWALK_ALERT_TIMER_SUBMIT_SUCCESS:
    return {
      ...state,
      timerId: payload.data.timer_id,
      formDuration: 0
    }
  default:
    return state
  }
}

export default reducer
